/*
 * THE LEFT END OF EVERY HEADER IN THE ASSISTANT — the app's own sticky bar, not a second drawing of one.
 *
 * There were two spellings of it: the thread's, inside `<vitesse-ai-chat>`'s shadow DOM, and the
 * agent tree's, hand-rolled in the panel's light DOM beside it. They were written to look the same
 * and did not, so stepping between the two surfaces moved things by a few pixels each way.
 *
 * ONE template now, used by both — and it is a COPY OF `.base-page-sticky-header`, which is the bar
 * every detail page in this product already has: a bare blue chevron, then the name, then whatever
 * the surface wants beside it. Nothing between them. A vertical rule was tried here and is gone: no
 * other header in the app has one, so it read as this surface inventing its own chrome, which is the
 * exact drift the shared template exists to prevent. What the base bar does, this does.
 *
 * A template function rather than an element: the two callers render into different DOM worlds (one
 * shadow, one light), and an element would need its styles duplicated into both anyway. The styles
 * ride along as `headLeadCss` so each caller adopts the same rules rather than restating them.
 */
import { html, css, nothing } from 'lit';
import '../elements/vitesse-icon';
export function headLead(o) {
    return html `
    ${o.onBack
        ? html `<button
            class="head-back"
            title=${o.backLabel}
            aria-label=${o.backLabel}
            @click=${() => o.onBack?.()}
            @mouseenter=${() => o.onBackHover?.()}
            @focus=${() => o.onBackHover?.()}
          >
            <vitesse-icon name="chevron-left" size="18"></vitesse-icon>
          </button>`
        : nothing}
    <span class="head-name">
      ${o.icon ? html `<vitesse-icon name=${o.icon} size="15"></vitesse-icon>` : nothing}${o.title}
    </span>
  `;
}
/** The rules for the above. Adopted by both callers so neither restates them. */
export const headLeadCss = css `
  /* .base-page-sticky-back-button, transcribed: a bare blue chevron, no box, no label. */
  .head-back {
    /* + the row's 8px gap = the base bar's 12px between the chevron and the name. */
    margin-right: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
    color: var(--blue-light);
    font: inherit;
    flex-shrink: 0;
    transition: color 0.12s ease;
  }
  .head-back:hover {
    color: hsl(from var(--blue-light) h s calc(l - 10%));
  }
  .head-name {
    flex: 0 1 auto;
    /* A FLOOR, so the name cannot be squeezed out of existence by badges that do not shrink. */
    min-width: 84px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 15px;
    font-weight: 500;
    color: var(--text-primary);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
//# sourceMappingURL=head-lead.js.map